import moment from 'moment-timezone';
import React from 'react';
import utils from '../../../../services/utils';
import FieldBold from '../../../Fields/FieldBold/FieldBold';

import classes from './InfoSalaryProcess.module.scss';

const InfoSalaryProcess = ({ collaborator, isProcess }) => {
  const {
    processPayDate,
    metadata: { salaryValue },
    payedValue,
    paymentDateTime
  } = collaborator;

  return (
    <div className={classes.content}>
      <span className='semibold-18'>Información salarial</span>
      <div className={classes.fields}>
        <FieldBold title='SALARIO NETO' value={utils.moneyFormat(salaryValue)} />
        <FieldBold title={isProcess ? 'MONTO A PAGAR' : 'MONTO PAGADO'} value={utils.moneyFormat(payedValue)} />
        <FieldBold
          title={isProcess ? 'FECHA Y HORA INICIO DE PAGO' : 'FECHA Y HORA PAGADO'}
          value={moment(isProcess ? processPayDate : paymentDateTime).format('DD/MM/YYYY[,] hh:mm a')}
        />
      </div>
    </div>
  );
};

export default InfoSalaryProcess;
